import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import { toast } from "react-toastify";

const HeaderSection = ({
  handleAddUserOpen,
  partnerName,
  searchQuery,
  setSearchQuery,
  handleSearch,
  fetchData,
  roleId,
}) => {
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const storedUserType = sessionStorage.getItem("uType");
    setUserType(storedUserType);
  }, []);

  const isAdmin = userType !== "RETAILER" && userType !== "SUBADMIN";

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    fetchData(0);
  };

  // ✅ Download CSV Handler
  const handleDownloadCSV = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/admin/getAllListUserWltBlcExport`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            roleId: roleId,
          },
        }
      );

      const data = response.data.body;
      if (!data || data.length === 0) {
        toast.error("No data found to download.");
        return;
      }

      // Define headers
      const headers = [
        "Role",
        "User Name",
        "Business Name",
        "Contact",
        "Parent ID",
        "Wallet Balance",
        "Status",
        "Total ChargeBack",
      ];

      // Build CSV rows
      const csvRows = [headers.join(",")]; // header row

      data.forEach((item) => {
        const row = [
          item.role,
          `"${item.userName}"`,
          `"${item.businessName}"`,
          item.contact,
          item.parentId,
          item.walletBalance,
          item.status,
          item.totalChargeBack,
        ];
        csvRows.push(row.join(","));
      });

      // Generate and trigger CSV file download
      const csvString = csvRows.join("\n");
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `User_Wallet_Report_Role_${roleId}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("CSV download error:", error);
      toast.error("Failed to download CSV.");
    }
  };

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography sx={{ fontWeight: "bold", fontSize: "22px" }}>
          {partnerName}
        </Typography>
      </Grid>

      <Grid item style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {/* Search Input */}
        <TextField
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchQuery && (
                  <IconButton onClick={handleClearSearch} size="small">
                    <ClearIcon />
                  </IconButton>
                )}
                <IconButton onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ minWidth: "250px" }}
        />

        {/* Buttons */}
        {isAdmin && (
          <>
            <Button
              variant="contained"
              onClick={handleAddUserOpen}
              startIcon={<ControlPointIcon />}
              sx={{
                backgroundColor: "green",
                color: "white",
                borderRadius: "8px",
                fontWeight: "bold",
                textTransform: "none",
                padding: "1rem",
                "&:hover": { backgroundColor: "darkgreen" },
              }}
            >
              Add User
            </Button>

          {userType === "ADMIN" && (
            <Button
              variant="contained"
              onClick={handleDownloadCSV}
              startIcon={<DownloadIcon />}
              sx={{
                backgroundColor: "#027BFE",
                color: "white",
                borderRadius: "8px",
                fontWeight: "bold",
                textTransform: "none",
                padding: "1rem",
                "&:hover": { backgroundColor: "#015dbb" },
              }}
            >
              Download CSV
            </Button>
          )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default HeaderSection;
